import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, ReplaySubject } from 'rxjs';
import { delay, retryWhen, switchMap } from 'rxjs/operators';
import { DealsStatsService } from '@prlw/core/monitor/deals-stats.service';
import { DealStatScale } from '@prlw/core/monitor/monitor.gateway';

const DEFAULT_SCALE: DealStatScale = '1m';
const RETRY_DELAY_MS = 1000;

@Injectable({
  providedIn: 'root',
})
export class PriceHistoryGraphService {
  private readonly instrumentCode$ = new ReplaySubject<string>();

  constructor(private readonly dealsStatsService: DealsStatsService) {}

  scale$ = new BehaviorSubject(DEFAULT_SCALE);

  chartData$ = combineLatest([this.instrumentCode$, this.scale$]).pipe(
    switchMap(([instrument, scale]) =>
      this.dealsStatsService
        .dealsStats$(instrument, scale)
        .pipe(retryWhen((errors$) => errors$.pipe(delay(RETRY_DELAY_MS)))),
    ),
  );

  public setScale(scale: DealStatScale): void {
    this.scale$.next(scale);
  }

  public setInstrumentCode(instrumentCode: string): void {
    this.instrumentCode$.next(instrumentCode);
  }
}
